import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { fontWeights } from '@/css/resources/variables.css';
import {
	grid,
	resetFirstLastMargins,
	linkUnderline,
	gridContentDefault,
	gridFull,
} from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidPadding,
	fluidValues,
	fluidMargin,
} from '@/css/resources/mixins.css';

const getStyles = () => css({});

export { getStyles };
